import React, { useState } from 'react'

export function MerchButton({data}) {

  let baseImage = data.imageUrl;
  let hoverImage = data.hoverImageUrl;
  
  const [hoveredImage, setHoveredImage] = useState(baseImage);
  const handleMouseEnter = () => {
    if(hoverImage !== null)
      setHoveredImage(hoverImage);
  };

  const handleMouseLeave = () => {
    setHoveredImage(baseImage);
  };
  
  return (
      <div key={data.name}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
      >
        <a href={data.url}>
          <img class="store-item-default" src={hoveredImage} />
          <span>{data.name}</span>
        </a>
      </div>
    );
  }

